export default __webpack_public_path__ + "static/media/logo.0b9b6bb0.png";